import useArticleId from './articleIdAtom';

export * from './articleIdAtom';

export default useArticleId;
